import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const MaintenanceRequestLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/maintenance'
            : '/dashboard/building-dashboard/maintenance'
        }
      >
        <span>
          {t('navbar:upsellingLinks.maintenance')}
          <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

MaintenanceRequestLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default MaintenanceRequestLink
